export default __webpack_public_path__ + "static/media/ic_bsc.8de996f1.svg";